module.exports = __webpack_public_path__ + "img/jimber-vault.a089e24c.png";